import { render, staticRenderFns } from "./TumblrButton.vue?vue&type=template&id=56975599&scoped=true&"
import script from "./TumblrButton.vue?vue&type=script&lang=js&"
export * from "./TumblrButton.vue?vue&type=script&lang=js&"
import style0 from "./TumblrButton.vue?vue&type=style&index=0&id=56975599&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56975599",
  null
  
)

export default component.exports